import { render, staticRenderFns } from "./KycForm.vue?vue&type=template&id=630ad23d&"
import script from "./KycForm.vue?vue&type=script&lang=js&"
export * from "./KycForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports